import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import PreprimarySidebar2026 from '../PreprimarySidebar2026';
import Presidebar2026 from '../Presidebar2026/Presidebar2026';


const OnamCelebration2026= () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/8.webp`;
  const p9 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/9.webp`;
  const p10 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/10.webp`;
  const p11 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/11.webp`;
  const p12 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/OnamCelebration/12.webp`;

  const photos = [
    {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},

{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},




  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
Onam Celebration
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
    Classes: KINDERGARTEN     Date: 25 August 2026
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
 Embracing the traditions of Kerala with joy and enthusiasm.
<br></br>
        </Typography>


        <Typography variant={'subtitle1'} align={'justify'}>
The spectacular festivities of <strong>Onam 2026 </strong>were celebrated on<strong> 25 August 2026</strong> by the Pre-
primary Department. Our little ambassadors embraced the spirit of Onam with immense
happiness, enthusiasm, and excitement.
      <br></br>
The celebration introduced our students from Kindergarten to the rich culture and traditions
of Kerala in a fun and meaningful way. The children came dressed in beautiful traditional
attire and looked adorable in their colourful outfits. To add on to the celebration, the students
carried sweet and savoury treats from the Kerala cuisine and relished it. They participated
enthusiastically in various activities such as Onam dance and art activities.
 <br></br>
A beautiful Pookalam (floral rangoli) was created as part of the celebration, adding colour and
festive spirit to the occasion, which helped students learn about the significance of Onam.
The celebration filled the atmosphere with smiles, laughter, music and togetherness much to
the spirit of this happy occasion. It was a wonderful opportunity for our young learners to
experience the beauty of Indian traditions and develop an appreciation for our rich cultural
heritage.
<br></br>


        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
Colours of flowers, smiles of children, and the spirit of Onam.

<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2026 />
             </Box>
             <Box marginBottom={4}>
               <Presidebar2026 />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default OnamCelebration2026;